import { useQuery } from '@apollo/client';
import type { UseDealGroupFetch } from '@openx/components-deal/lib/utils/context/DealHookTypes';
import { mapRboConfigFields } from '@openx/components-deal/lib/utils/mapRboConfig';
import { useMemo } from 'react';
import { GetDealsListBasicDocument } from '../../../graphql/query/deals/GetDealsListBasic.generated';

export const useDealGroupFetch: UseDealGroupFetch = (dealId, historyMode) => {
  const { data, loading } = useQuery(GetDealsListBasicDocument, {
    fetchPolicy: 'network-only',
    skip: !dealId || historyMode,
    variables: {
      queryString: `deal_id__in=${dealId}&limit=9999`,
    },
  });

  const objects = data?.deals?.objects;

  const group = useMemo(
    () =>
      objects?.map(({ name, exchange_id, exchange_uid, exchange_package, exchange_deal }) => ({
        id: exchange_id || '',
        name: name || '',
        rboConfig: mapRboConfigFields(exchange_deal?.rbo_config),
        targetingWithUrlTargeting: {
          ...exchange_package?.targeting,
          url_targeting: exchange_package?.url_targeting,
        },
        uid: exchange_uid || '',
      })) || [],
    [objects]
  );

  return {
    group,
    loading,
  };
};
